export default "__VITE_ASSET__Qzg40vEA__"